export const GRAPHIC_ACCENT_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/graphicAccentSchemaV1_0_0.json' as const;
export const GRAPHIC_ACCENT_COMPONENT_TYPE = 'GraphicAccent' as const;
